module.exports = __webpack_public_path__ + "static/media/icon_borrar_list.8283fdba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_borrar_list.svg
// module id = 618
// module chunks = 0